// @ts-nocheck
import type * as Types from '../../../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import { CurrentUserOrderFragmentDoc } from '../../../graphql/current-user-orders';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DonorPortalRestartRecurringDonationMutationVariables = Types.Exact<{
  input: Types.DonorPortalRestartRecurringDonationInput;
}>;


export type DonorPortalRestartRecurringDonationMutation = { __typename?: 'Mutation', donorPortalRestartRecurringDonation: { __typename?: 'CurrentUserOrder', id: string, created: number, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, canceled?: number | null, nextPayment?: number | null, lastPaymentDate?: number | null, paymentFailing: boolean, canRestart: boolean, paymentMethodType: Types.CurrentUserPaymentMethodType, campaignTitle?: string | null, workspaceWebId: string, utm: { __typename?: 'UtmData', medium?: string | null, source?: string | null, campaign?: string | null, content?: string | null } } };


export const DonorPortalRestartRecurringDonationDocument = /*#__PURE__*/ gql`
    mutation DonorPortalRestartRecurringDonation($input: DonorPortalRestartRecurringDonationInput!) {
  donorPortalRestartRecurringDonation(input: $input) {
    ...CurrentUserOrder
  }
}
    ${CurrentUserOrderFragmentDoc}`;

/**
 * __useDonorPortalRestartRecurringDonationMutation__
 *
 * To run a mutation, you first call `useDonorPortalRestartRecurringDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDonorPortalRestartRecurringDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [donorPortalRestartRecurringDonationMutation, { data, loading, error }] = useDonorPortalRestartRecurringDonationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDonorPortalRestartRecurringDonationMutation(baseOptions?: Apollo.MutationHookOptions<DonorPortalRestartRecurringDonationMutation, DonorPortalRestartRecurringDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DonorPortalRestartRecurringDonationMutation, DonorPortalRestartRecurringDonationMutationVariables>(DonorPortalRestartRecurringDonationDocument, options);
      }
export type DonorPortalRestartRecurringDonationMutationHookResult = ReturnType<typeof useDonorPortalRestartRecurringDonationMutation>;